import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import store from '../../../../store';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const CrmsIndex = () => import('./Index.vue');
const GClickIndex = () => import('./gclick/Index.vue');

// Num refresh direto na URL a conta ainda pode não estar carregada
const ensureGclickEnabled = async to => {
  const { accountId } = to.params;
  if (!store.getters['accounts/getAccount'](accountId).id) {
    await store.dispatch('accounts/get');
  }
  if (
    store.getters['accounts/isFeatureEnabledonAccount'](
      accountId,
      FEATURE_FLAGS.GCLICK
    )
  ) {
    return true;
  }
  return { name: 'settings_home', params: to.params };
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/crms'),
      component: SettingsWrapper,
      beforeEnter: ensureGclickEnabled,
      children: [
        {
          path: '',
          name: 'settings_crms_index',
          meta: {
            permissions: ['administrator'],
          },
          component: CrmsIndex,
        },
        {
          path: 'gclick',
          name: 'settings_crms_gclick',
          meta: {
            permissions: ['administrator'],
          },
          component: GClickIndex,
        },
      ],
    },
  ],
};
